
export const TypeResto: string[]  = ["Restaurant Traditionnel", "Brasserie", "Bistrot", "Restaurant Bistronomique", "Restaurant Gastronomique", "Crêperie", "Pizzeria", "Restaurant à Volonté","Street food", "Auberge-Restaurant", "Hôtel-Restaurant", "Bar-Restaurant", "Restaurant Ouvrier", "Guinguette" , "Bouillon"
] 

export const feminineClassicTypes = [
  "Brasserie",
  "Crêperie",
  "Pizzeria",
  "Guinguette",
  "Auberge-Restaurant"
];

export const compatibilitesType:{ [key: string]: [string[]] } = {
    "Auberge-Restaurant": [[" Traditionnel", " Bistronomique", " Gastronomique", " et Bistrot", " et Brasserie", " Ouvrier", " et Crêperie", " et Pizzeria", " à Thème", " à Volonté", " et Guinguette"]],
    "Hôtel-Restaurant": [[" Traditionnel", " Bistronomique", " Gastronomique", " et Bistrot", " et Brasserie", " Ouvrier", " et Crêperie", " et Pizzeria", " à Thème", " à Volonté", " et Guinguette"]],
    "Bar-Restaurant": [[" Traditionnel", " Bistronomique", " Gastronomique", " Ouvrier", " et Crêperie", " et Pizzeria", " à Thème", " à Volonté", " et Guinguette"]],
    "Restaurant Ouvrier": [[" et Traditionnel", " et Bistrot", " et Brasserie", " et Crêperie", " et Pizzeria", " à Thème", " à Volonté", " et Guinguette"]],
    "Restaurant à Thème": [[" et Traditionnel", " et Bistronomique", " et Gastronomique", " et Bistrot", " et Brasserie", " et Crêperie", " et Pizzeria", " et à Volonté"]],
    "Restaurant Traditionnel": [[" et Bistronomique", " et Gastronomique", " et Bistrot", " et Brasserie", " et Ouvrier", " et Crêperie", " et Pizzeria", " à Thème", " à Volonté", " et Guinguette"]],
    "Guinguette": [[" et Restaurant Traditionnel", " et Restaurant Bistronomique", " et Restaurant Gastronomique", " et Bistrot", " et Brasserie", " et Restaurant Ouvrier", " et Crêperie", " et Pizzeria", " à Thème", " à Volonté"]],
    "Bistrot": [[" et Restaurant Traditionnel", " et Restaurant Bistronomique", " et Restaurant Gastronomique", " et Brasserie", " et Restaurant Ouvrier", " et Crêperie", " et Pizzeria", " à Thème", " à Volonté", " et Guinguette"]],
    "Brasserie": [[" et Restaurant Traditionnel", " et Restaurant Bistronomique", " et Restaurant Gastronomique", " et Bistrot", " et Restaurant Ouvrier", " et Crêperie", " et Pizzeria", " à Thème", " à Volonté", " et Guinguette"]],
    "Restaurant Bistronomique": [[" et Traditionnel", " et Gastronomique", " et Bistrot", " et Brasserie", " et Crêperie", " et Pizzeria", " à Thème", " à Volonté", " et Guinguette"]],
    "Restaurant Gastronomique": [[" et Traditionnel", " et Bistronomique", " et Bistrot", " et Brasserie", " et Crêperie", " et Pizzeria", " à Thème", " à Volonté", " et Guinguette"]],
    "Crêperie": [[" Traditionnelle", " Bistronomique", " Gastronomique", " et Bistrot", " et Brasserie", " et Restaurant Ouvrier", " et Pizzeria", " à Thème", " à Volonté", " et Guinguette"]],
    "Pizzeria": [[" Traditionnelle", " Bistronomique", " Gastronomique", " et Bistrot", " et Brasserie", " et Restaurant Ouvrier", " et Crêperie", " à Thème", " à Volonté", " et Guinguette"]],
    "Restaurant à Volonté": [[" à Thème"]],
  }

export const TYPE_PREFIXES = ["dish", "country", "regime","french-region","cultural-region","concept-unique"] as const;
export type RestaurantTypeKind = "classic" | typeof TYPE_PREFIXES[number];
export interface ParsedRestaurantType {
  kind: RestaurantTypeKind;
  value: string;
}

export const listeDietaryRegimes = ["Restaurant Végétarien","Restaurant Végan","Restaurant Halal","Restaurant Kasher"];


export const parseRestaurantType = (raw: string): ParsedRestaurantType => {
  const colonIndex = raw.indexOf(":");

  if (colonIndex !== -1) {
    const prefix = raw.slice(0, colonIndex).trim();
    const value = raw.slice(colonIndex + 1).trim();

    if (TYPE_PREFIXES.includes(prefix as any) && value) return {kind: prefix as RestaurantTypeKind,value};
  }
  return {kind: "classic",value: raw};
};

export const extractSecondType = (type: string) => {
  const parsed = parseRestaurantType(type);

  if (parsed.kind !== "classic") {
    return parsed.value;
  }
  const words = parsed.value.trim().split(/\s+/);
  return words.length > 1 ? words.slice(1).join(" ") : words[0];
};

export const extractLastWord = (type: string) => {
  const parsed = parseRestaurantType(type);

  const words = parsed.value.trim().split(/\s+/);  
  return words[words.length - 1];  
};

export const buildSingleRestaurantTypeLabel = (rawType: string) => {
if (!rawType) return "";
  const type = parseRestaurantType(rawType);

  if (type.kind === "classic") return type.value;
  if (type.kind === "dish" || type.kind === "country" || type.kind === "french-region" || type.kind === "cultural-region" || type.kind === "regime" || type.kind === "concept-unique") return `${type.value}`;

  return type.value;
};

export const buildRestaurantTypeLabel = (types: string[]) => {
  if (!types || types.length === 0) return "";

  return types
    .map(buildSingleRestaurantTypeLabel)
    .filter(Boolean)
    .join(" - ");
};

export const normalizeTypeValue = (value: string) => {
  return value
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim();
};

export const isTypedRestaurantFilter = (filter: string) => {
  const parsed = parseRestaurantType(filter);

  return (
    parsed.kind !== "classic" ||
    TypeResto.includes(parsed.value)
  );
};

export const restaurantTypeMatchesFilter = (rawRestaurantType: string,selectedFilter: string) => {
  const restaurantType = parseRestaurantType(rawRestaurantType);
  const filterType = parseRestaurantType(selectedFilter);

  if (restaurantType.kind !== filterType.kind) {return false}

  if (restaurantType.kind !== "classic") {
    return (
      normalizeTypeValue(restaurantType.value) ===
      normalizeTypeValue(filterType.value)
    );
  }

  return (
    normalizeTypeValue(rawRestaurantType) === normalizeTypeValue(selectedFilter) ||
    normalizeTypeValue(extractLastWord(rawRestaurantType)).includes(
      normalizeTypeValue(extractLastWord(selectedFilter))
    )
  );
};